import { User } from '../../Models/User';

export interface IUserState {
    // userDetails: User;
    error: any;
    success: any;
    userLoggedInInfo: User;
    userLoggedInError:any;
    sendLinkForgotPswdSuccess: any;
    sendLinkForgotPswdError: any;
    resetPasswordSuccess : any;
    resetPasswordError : any;
    updateTermsSuccess : any;
    updateTermsError : any;
    checkResetPswdLinkSuccess : any;
    checkResetPswdLinkError : any;
    resetPswdByLinkSuccess : any;
    resetPswdByLinkError : any;
    // alladminusers: any;
    // admindetails: any;
}
export const initialUserState: IUserState = {
    // userDetails: JSON.parse(sessionStorage.getItem('userDetails')),
    error: null,
    success: null,
    userLoggedInInfo: JSON.parse(sessionStorage.getItem('userDetails')),
    userLoggedInError: null,
    sendLinkForgotPswdSuccess: null,
    sendLinkForgotPswdError: null,
    resetPasswordSuccess : null,
    resetPasswordError : null,
    updateTermsSuccess : null,
    updateTermsError : null,
    checkResetPswdLinkSuccess : null,
    checkResetPswdLinkError : null,
    resetPswdByLinkSuccess : null,
    resetPswdByLinkError : null
    // updateTermsSuccess : null,
    // updateTermsError:null
    // alladminusers: [],
    // admindetails: {}
};
